import { UPDATE_STEP } from '../actions/types';
export default function(state = 1, action) {
  switch (action.type) {
    case UPDATE_STEP:
      return action.payload
    default:
      // Form starts on step 1
      return state;
  }
}